import getStore from 'services/getStore';
import { cloneBlock } from '@chameleoncreator/creator-app';
import { setBlockAction } from "actions/setBlockAction";

let newBlocks = {};
let delayUpdate;

export default (block, props) => {
  if (!newBlocks[block.id]) {
    newBlocks[block.id] = cloneBlock(block);
  }

  newBlocks[block.id].props = { ...newBlocks[block.id].props, ...props };

  clearTimeout(delayUpdate);

  delayUpdate = setTimeout(() => {
    Object.values(newBlocks).forEach((b: any) => {
      getStore().dispatch(setBlockAction(b));
    });
    newBlocks = {};
  }, 1000 / 60);
};
